const loggedOutMenuItems = [
  {
    id: 'featured',
    label: 'Featured',
    to: '/',
    isActive: (match, location) => {
      if (!location) return false
      return location.pathname === '/'
    }
  },
  {
    id: 'search',
    label: 'Search',
    to: '/search'
  }
]

const loggedInMenuItems = [
  {
    id: 'my-events',
    label: 'My Events',
    to: '/my-events'
  }
]

export default (isLoggedIn) => [
  ...loggedOutMenuItems,
  ...(isLoggedIn ? loggedInMenuItems : [])
]
